export enum E_AppRoutes {
  LOGIN = '/login',
  UNREGISTERED_CUSTOMER = '/unregistered-customer',
  POST_REGISTRATION = '/post-registration',
  REGISTERED_CUSTOMER = '/registered-customer',
  REDEMPTION = '/redemption',
  FLEXIBLE_POINTS = '/flexible-points',
}
